module.exports = __webpack_public_path__ + "img/LA.21ec75c1.png";